var ezdia;
(function (ezdia) {
    var TEMPLATE = ezdia.templates.navbar;
    var Navbar = /** @class */ (function () {
        function Navbar() {
        }
        Navbar.prototype.render = function (navItems) {
            var htmlContent = TEMPLATE.getMarkup(navItems);
            $('#primary-navbar').replaceWith(htmlContent);
        };
        return Navbar;
    }());
    var component;
    (function (component) {
        component.navbar = new Navbar();
    })(component = ezdia.component || (ezdia.component = {}));
})(ezdia || (ezdia = {}));
